export default __webpack_public_path__ + "static/media/SignUpPC.ec00d212.svg";